import './basicDetails.less'
import WidgetCard from '../../../../../../components/WidgetCard'
import { BasicDetailsIcon } from '../../common/icon'
import Label from '../../../../../../components/Label'
import { usePolicyParametersContext } from '../../../context/policyParametersContext'
import { capitalizeFirstLetter } from '../../../../../ropa/ropaUtil'
import { SYSTEM_DATA_TYPES } from '../../../types'
import React from 'react'
import { useIntl } from 'react-intl'
import { Input, TextArea, Toggle, Typography } from '@lightbeamai/design-system'

export const dataTypeOptions = Object.values(SYSTEM_DATA_TYPES).map((type) => ({
  key: type,
  value: type,
  label: capitalizeFirstLetter(type as string)
}))

export const BasicDetails = () => {
  const intl = useIntl()
  const { basicDetails, patchBasicDetails, mode } = usePolicyParametersContext()

  const { isView } = mode
  return (
    <WidgetCard
      widgetTitle={{
        title: intl.formatMessage({
          id: 'attributeManagementSettings.customAttributes.basicDetails'
        }),
        icon: <BasicDetailsIcon />,
        bordered: true
      }}
      className="xs-pb-24 policy-params-basic-details"
    >
      <Typography type="medium">
        {intl.formatMessage({
          id: 'policy.settings.parameters.basicDetails.description'
        })}
      </Typography>
      <div className="basic-details-form">
        <div className="basic-details-form-item">
          <Label
            className="xs-mt-24"
            transId="policy.settings.parameters.basicDetails.name"
            required
            variant="base"
          />
          <Input
            value={basicDetails.name}
            onChange={(e) => patchBasicDetails({ name: e.target.value })}
            placeholder={intl.formatMessage({ id: 'policy.settings.parameters.basicDetails.name' })}
            disabled={isView}
          />
        </div>
        <div className="basic-details-form-item">
          <Label transId="description" variant="base" />
          <TextArea
            value={basicDetails.description}
            onChange={(e) => patchBasicDetails({ description: e.target.value })}
            placeholder={intl.formatMessage({ id: 'description' })}
            disabled={isView}
          />
        </div>
        {/* <div className="basic-details-form-item">
          <Label
            transId="policy.settings.parameters.basicDetails.dataType"
            required
            variant="base"
          />
          <Select
            value={basicDetails.dataType}
            onChange={(val) => patchBasicDetails({ dataType: val })}
            placeholder={intl.formatMessage({
              id: 'policy.settings.parameters.basicDetails.dataType'
            })}
            style={{ width: '100%' }}
            options={dataTypeOptions}
            disabled={!isCreate}
          />
        </div> */}
        <div className="basic-details-form-item">
          <Toggle
            value={basicDetails.enabled}
            onChange={(val) => patchBasicDetails({ enabled: val })}
            disabled={isView}
            title={intl.formatMessage({ id: 'policy.settings.paramerters.enable' })}
            size={16}
          />
        </div>
      </div>
      <Typography className="xs-mt-8">
        {intl.formatMessage({ id: 'policy.settings.paramerters.enable.info' })}
      </Typography>
    </WidgetCard>
  )
}
